import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setShowLoginModal } from "../../redux/reducer/modalReducer";
import HoverPopover from "../ui/HoverPopover";

export const isStaff = (user) => user?.role === "admin" || user?.role === "employee";

export const accountLinks = (user) => [
  { to: "/account", icon: "bi-person", label: "Thông tin tài khoản" },
  { to: "/orders", icon: "bi-box-seam", label: "Đơn hàng của tôi" },
  ...(isStaff(user) ? [{ to: "/dashboard", icon: "bi-speedometer2", label: "Trang quản trị", external: true }] : []),
];

/** Nút tài khoản trên header desktop: chưa đăng nhập → mở modal; đã đăng nhập → dropdown. */
const AccountMenu = ({ onLogout }) => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.authReducer?.login);
  // Link ảnh hỏng (vd. link Facebook cũ đã hết hạn) → hiện icon thay vì ảnh vỡ
  const [brokenAvatar, setBrokenAvatar] = useState(null);

  if (!currentUser) {
    return (
      <button
        type="button"
        onClick={() => dispatch(setShowLoginModal(true))}
        className="flex items-center gap-2 rounded-xl px-2 py-1.5 text-left text-white transition-colors hover:bg-white/10"
      >
        <i className="bi bi-person-circle text-2xl leading-none" aria-hidden="true" />
        <span className="flex flex-col leading-tight">
          <span className="text-sm text-white/80">Xin chào</span>
          <span className="text-base font-semibold">Đăng nhập</span>
        </span>
      </button>
    );
  }

  const name = currentUser?.fullname || currentUser?.username || "Tài khoản";

  return (
    <HoverPopover
      content={
        <div className="w-60 rounded-2xl bg-white p-2 shadow-pop ring-1 ring-black/5">
          <div className="border-b border-slate-100 px-3 pb-3 pt-2">
            <p className="m-0 truncate text-base font-semibold text-slate-900">{name}</p>
            {currentUser?.email && <p className="m-0 truncate text-sm text-slate-500">{currentUser.email}</p>}
          </div>
          <ul className="m-0 list-none p-0 pt-1">
            {accountLinks(currentUser).map((l) => (
              <li key={l.to} className="list-none">
                <Link
                  to={l.to}
                  target={l.external ? "_blank" : undefined}
                  className="flex items-center gap-3 rounded-lg px-3 py-2 text-base text-slate-700 no-underline transition-colors hover:bg-slate-50 hover:text-brand-700"
                >
                  <i className={`bi ${l.icon} text-lg text-slate-400`} aria-hidden="true" />
                  {l.label}
                </Link>
              </li>
            ))}
            <li className="list-none">
              <button
                type="button"
                onClick={onLogout}
                className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left text-base text-slate-700 transition-colors hover:bg-sale-50 hover:text-sale-600"
              >
                <i className="bi bi-box-arrow-right text-lg text-slate-400" aria-hidden="true" />
                Đăng xuất
              </button>
            </li>
          </ul>
        </div>
      }
    >
      <button type="button" aria-haspopup="true" className="flex items-center gap-2 rounded-xl px-2 py-1.5 text-left text-white transition-colors hover:bg-white/10">
        {currentUser?.avatar && currentUser.avatar !== brokenAvatar ? (
          <img
            src={currentUser.avatar}
            alt=""
            width={28}
            height={28}
            referrerPolicy="no-referrer"
            onError={() => setBrokenAvatar(currentUser.avatar)}
            className="h-7 w-7 rounded-full object-cover ring-2 ring-white/40"
          />
        ) : (
          <i className="bi bi-person-circle text-2xl leading-none" aria-hidden="true" />
        )}
        <span className="flex max-w-[120px] flex-col leading-tight">
          <span className="text-sm text-white/80">Tài khoản</span>
          <span className="truncate text-base font-semibold">{name}</span>
        </span>
      </button>
    </HoverPopover>
  );
};

export default AccountMenu;
